import { reportUnexpectedError } from '@/shared/infrastructure/observability/reportUnexpectedError'
import type { LeadRepository } from '../application/LeadRepository'

export function createResilientLeadRepository(
  primary: LeadRepository,
  fallback: LeadRepository,
): LeadRepository {
  return {
    async list(filters) {
      try {
        return await primary.list(filters)
      } catch (error) {
        reportUnexpectedError(error, { feature: 'leads', operation: 'list', fallback: true })
        const result = await fallback.list(filters)
        return {
          ...result,
          meta: { ...result.meta, source: 'fixture-fallback', fallbackReason: 'LEADS_REMOTE_UNAVAILABLE' },
        }
      }
    },
    async getByReference(reference) {
      try {
        return await primary.getByReference(reference)
      } catch (error) {
        reportUnexpectedError(error, { feature: 'leads', operation: 'detail', fallback: true })
        const result = await fallback.getByReference(reference)
        return result
          ? {
              ...result,
              meta: {
                ...result.meta,
                source: 'fixture-fallback',
                fallbackReason: 'LEADS_REMOTE_UNAVAILABLE',
              },
            }
          : null
      }
    },
    // Une écriture ne se replie jamais sur les fixtures.
    create(command) {
      return primary.create(command)
    },
    changeStatus(command) {
      return primary.changeStatus(command)
    },
    updateAddress(command) {
      return primary.updateAddress(command)
    },
    findDuplicates(leadId) {
      return primary.findDuplicates(leadId)
    },
    convert(command) {
      return primary.convert(command)
    },
    completeReminder(command) {
      return primary.completeReminder(command)
    },
    recordCallOutcome(command) {
      return primary.recordCallOutcome(command)
    },
    delete(leadId) {
      return primary.delete(leadId)
    },
    // Une provenance indisponible s'affiche comme telle, jamais comme « Inconnue » : aucun repli.
    getAttribution(leadId) {
      return primary.getAttribution(leadId)
    },
    setDeclaredSource(command) {
      return primary.setDeclaredSource(command)
    },
    geocodeAddress(command) {
      return primary.geocodeAddress(command)
    },
  }
}
